// Replaced home.tsx

import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_default/')({
  component: Index,
})

function Index() {
  return (
    <div className="h5 p-4">Homepage content in development. Select an organization from the dropdown in the header.</div>
  )
}